<style lang="scss">
  @import "@/assets/scss/vuexy/components/minMaxItem";
</style>
<template>
  <div class="m-3 px-2 py-4 border-2 container-item w-full">
      <div class="text-right">
        <feather-icon
        icon="EditIcon"
        @click="edit = true"
        class="cursor-pointer"
        svgClasses="hover:text-primary"
        v-if="!edit && $store.state.AppActiveUser.userRole === 'MA'"/>
        <feather-icon
        icon="SaveIcon"
        @click="send()"
        class="cursor-pointer"
        svgClasses="hover:text-primary"
        v-if="edit"
        />
        <feather-icon
        icon="XIcon"
        @click="cancel()"
        class="cursor-pointer"
        svgClasses="hover:text-primary"
        v-if="edit"
        />
      </div>
      <div class="block" v-if="!edit">
          <div class="text-center">
            <div>{{$t("Labels.TimeDoor")}}</div>
            <div class="inline-block align-middle mr-1"><img class="h-8" :src="getImgUrl('clock')" alt="icono de reloj" /></div>
            <div class="inline-block align-middle">{{ editVal }}<span class="unit">s</span></div>
          </div>
          <div class="mt-2 text-center">{{$t('Labels.ActiveAlerts')}}:</div>
          <ul>
            <li class="my-1">
              <vs-checkbox v-model="editAlertOpen" disabled="true">{{$t('Labels.OpenAlert')}}</vs-checkbox>
            </li>
            <li class="my-1">
              <vs-checkbox v-model="editAlertLongOpen" disabled="true">{{$t('Labels.LongOpenAlert')}}</vs-checkbox>
            </li>
          </ul>
      </div>
      <div class="block container-inputs" v-if="edit">
        <div class="text-center">
            <div>{{$t("Labels.TimeDoor")}}</div>
            <div>
                <span class="font-bold">{{$t("Labels.Seconds")}}</span>
                <vs-input-number :min="0" :max="255" v-model="editVal"   class="text-xs"/>
            </div>
            <div class="mt-2">{{$t('Labels.ActiveAlerts')}}:</div>
            <ul>
              <li class="my-1">
                <vs-checkbox v-model="editAlertOpen">{{$t('Labels.OpenAlert')}}</vs-checkbox>
              </li>
              <li class="my-1">
                <vs-checkbox v-model="editAlertLongOpen">{{$t('Labels.LongOpenAlert')}}</vs-checkbox>
              </li>
            </ul>
        </div>
      </div>
  </div>
</template>
<script>
import { request } from '@/request.js'

export default {
  props: {
    val: {
      type: Number,
      required: true
    },
    uuid: {
      type: String,
      required: true
    },
    alertOpen: {
      type: Boolean,
      required: true
    },
    alertLongOpen: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      edit: false,
      editVal: 0,
      editAlertOpen: false,
      editAlertLongOpen: false
    }
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${name}.svg`)
    },
    async send () {
      const params = {
        url: `modelo/doors/${this.uuid}`,
        method: 'PUT',
        params: {
          long_alert_timeout: this.editVal,
          long_alert_enable: this.editAlertOpen === true ? 1 : 0,
          open_alert_enable: this.editAlertLongOpen === true ? 1 : 0
        }
      }

      await request(params).then().finally(() => {
        this.edit = false
      })
    },
    cancel () {
      this.editVal = this.val
      this.editAlertOpen = this.alertOpen
      this.editAlertLongOpen = this.alertLongOpen
      this.edit = false
    }
  },
  created () {
    this.editVal = this.val
    this.editAlertOpen = this.alertOpen
    this.editAlertLongOpen = this.alertLongOpen
  }
}
</script>
